import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisibilityChangeService {
  private readonly documentHidden$ = new BehaviorSubject(false);

  documentIsActive$ = this.documentHidden$.pipe(
    filter((item) => item === false),
  );

  constructor() {
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.documentHidden$.next(true);
        return;
      }
      this.documentHidden$.next(false);
    });
  }
}
